<template><div><h1 id="beziehungen" tabindex="-1"><a class="header-anchor" href="#beziehungen"><span>Beziehungen</span></a></h1>
<p>Beziehungen — Abbildung von Beziehungen zwischen Personen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert Beziehungen zwischen Personen. Dabei handelt es sich z.B. um Haushaltsbeziehungen, Lehrer/Schüler-Beziehung, Partnerbeziehung, oder Beziehungen zwischen Privatpersonen und Organisationen. Die Beziehungen sind in der Stammtabelle <RouteLink to="/referenz/refs/ft.refdata.tbladrbez.html" title="Personenbeziehung">Beziehungen</RouteLink> definiert. Die Beziehungen gehen immer von einer A- zu einer B-Person, wobei die Beziehung selbst reziprok wirkt (von beiden Seiten her gesehen funktioniert).</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder-anzeige" tabindex="-1"><a class="header-anchor" href="#datenfelder-anzeige"><span>Datenfelder (Anzeige)</span></a></h2>
<dl>
<dt>Beziehung</dt>
<dd>Hierarchische Anzeige der Personenbeziehungen. Unterhalb der einzelnen Beziehungen werden die Personen angezeigt. Mit Doppelklick auf die Personenzeile springt der Fokus auf die entsprechende Person.</dd>
<dt>Personen-ID</dt>
<dd>Personen-ID der Beziehungsperson.</dd>
<dt>Status</dt>
<dd>Personenstatus der Beziehungsperson.</dd>
<dt>von/bis</dt>
<dd>Gültigkeit der Beziehung (Datum von/bis)</dd>
</dl>
<h2 id="datenfelder-erfassungsmodus" tabindex="-1"><a class="header-anchor" href="#datenfelder-erfassungsmodus"><span>Datenfelder (Erfassungsmodus)</span></a></h2>
<dl>
<dt>Person</dt>
<dd>Personen-ID und Person einzeilig zur visuellen Kontrolle (Read-Only)</dd>
<dt>Richtung</dt>
<dd>Mögliche Werte sind &quot;ist&quot;, &quot;hat&quot; oder &quot;leer&quot; (bei ungerichteten Beziehungen wie Haushalte, etc.).</dd>
<dt>Beziehung</dt>
<dd>Auswahl einer vordefinierten Beziehung aus der Stammtabelle <a class="link" href="ft.refdata.tbladrbez.html" title="Personenbeziehung">Beziehungen</a></dd>
<dt>B-Person</dt>
<dd>Personen-ID, die zur angezeigten Person in Beziehung steht.</dd>
<dt>Gültig ab</dt>
<dd>Start-Datum der Beziehung.</dd>
<dt>Gültig bis</dt>
<dd>End-Datum der Beziehung.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="richtung-wechseln" tabindex="-1"><a class="header-anchor" href="#richtung-wechseln"><span>Richtung wechseln</span></a></h3>
<p>Mit Dopplklick: Austausch der Inhalte der Fenster Adresse und B-Person, zeigt die definierten Beziehungen mit reziproken Werten.</p>
<h3 id="beziehung-beenden" tabindex="-1"><a class="header-anchor" href="#beziehung-beenden"><span>Beziehung beenden</span></a></h3>
<p>Mit Standardfunktion Löschen: Bestehende Beziehungen können entweder komplett gelöscht (ohne Historisierung) oder beendet (mit Historisierung) werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tbladrbez.html" title="Personenbeziehung">Beziehungen</RouteLink></p>
</div></template>


